import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Tabs,
  Tab,
  Box,
  Alert,
} from "@mui/material";

import AddUserRootsForm from "../Permissins/LinkUnlinkRoot/AddUserRootsForm";
import RemoveUserRootButton from "../Permissins/LinkUnlinkRoot/RemoveUserRootButton";
import UserBankPermissionsData from "../Permissins/Banks/UserBankPermissionsData";
import CashiersListByBranch from "../Permissins/Cashiers/CashiersListByBranch";
import UserActiveBranchesList from "../Permissins/LinkUnlinkRoot/UserActiveBranchesList"; // ✅ المكون الجديد

const UserActionsModal = ({ user, open, onClose, onUpdated }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [permissionsSection, setPermissionsSection] = useState("branches");
  const [branchesKey, setBranchesKey] = useState(0); // ✅ مفتاح لتحديث الفروع

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const hasBranches = user?.roots?.length > 0; // ✅ Check if the user has linked branches

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        إدارة المستخدم: {user?.name || `ID: ${user?.id}`}
      </DialogTitle>

      <DialogContent>
        {!hasBranches && ( // ✅ Show alert if no branches are linked
          <Alert severity="warning" sx={{ mb: 2 }}>
            برجاء ربط المستخدم بالفروع للتمكين من إضافة صلاحيات.
          </Alert>
        )}

        <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
          <Tab label="الصلاحيات" />
        </Tabs>

        {tabIndex === 0 && (
          <Box>
            <Box display="flex" gap={2} mb={2} flexWrap="wrap">
              <Button
                variant={
                  permissionsSection === "branches" ? "contained" : "outlined"
                }
                onClick={() => setPermissionsSection("branches")}
              >
                ربط الفروع
              </Button>

              <Button
                variant={
                  permissionsSection === "cashiers" ? "contained" : "outlined"
                }
                onClick={() => setPermissionsSection("cashiers")}
              >
                الكاشيرات
              </Button>
              <Button
                variant={
                  permissionsSection === "banks" ? "contained" : "outlined"
                }
                onClick={() => setPermissionsSection("banks")}
              >
                صلاحيات الخزن
              </Button>
            </Box>

            {permissionsSection === "branches" && (
              <Box display="flex" gap={4} flexWrap="wrap">
                <Box flex={1} minWidth={300}>
                  <Typography variant="h6" gutterBottom>
                    ربط بفروع
                  </Typography>
                  <AddUserRootsForm
                    userId={user?.id}
                    onSuccess={() => {
                      onUpdated();
                      setBranchesKey((prev) => prev + 1);
                    }}
                  />
                </Box>
                <Box flex={1} minWidth={300}>
                  <Typography variant="h6" gutterBottom>
                    إلغاء ربط فرع
                  </Typography>
                  <RemoveUserRootButton
                    userId={user?.id}
                    onSuccess={() => {
                      onUpdated();
                      setBranchesKey((prev) => prev + 1);
                    }}
                  />
                </Box>
                <Box width="100%">
                  <UserActiveBranchesList
                    key={branchesKey} // ✅ يعيد تحميل المكون عند التغيير
                    userId={user?.id}
                  />
                </Box>
              </Box>
            )}
            {permissionsSection === "cashiers" && (
              <CashiersListByBranch
                rootId={user?.roots?.[0]?.id || 0}
                userId={user?.id}
                onSuccess={onUpdated}
              />
            )}

            {permissionsSection === "banks" && (
              <UserBankPermissionsData user={user} onSuccess={onClose} />
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>إغلاق</Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserActionsModal;
